module.exports = __webpack_public_path__ + "img/360.47e67ec1.svg";